import React from 'react';
import PropTypes from 'prop-types';
import { Col, FormGroup, ControlLabel, HelpBlock, FormControl, Button } from 'react-bootstrap';
import { withTranslation } from 'react-i18next';

const List = ({ horizontal, label, data, onClick, isReadonly, labelCol, valueCol, t, ...props }) => {

	const cultures = data ? Object.values(data) : [];
	const links =
		<ul style={{ listStyle: 'none', margin: 0, padding: 0, overflow: 'hidden' }}>
			{cultures.map(localization => <li key={localization.id} style={{ float: 'left' }}><Button active onClick={() => onClick(localization)}>{localization.languageName}</Button>&nbsp;</li>)}
			{!isReadonly && < li key='new' style={{ float: 'left' }}> <Button bsStyle={'success'} onClick={() => onClick()}>{t('Localisation_Add')}</Button></li>}
		</ul>;
	if (!labelCol) {
		labelCol = 2;
	}
	if (!valueCol) {
		valueCol = 10;
	}
	return (
		<FormGroup>
			<Col sm={valueCol} smOffset={labelCol}>
				<div style={{ marginTop: '-5px',  marginBottom:'5px' }}>{label}</div>
				<div>{links}</div>
			</Col>
		</FormGroup>);
};

List.propTypes = {
	label: PropTypes.string,
};

export default withTranslation()(List);